import { createContext, ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { FeatureFlags } from '../services';

export const FeatureFlagsContext = createContext<{ featureFlags: FeatureFlags }>(null!);

type FeatureFlagsProviderProps = {
  children?: ReactNode;
  featureFlags: FeatureFlags;
};
const maxTryCount = 50;

export const FeatureFlagsProvider = ({ children, featureFlags }: FeatureFlagsProviderProps) => {
  const [updateCount, setStateUpdateCount] = useState(0);
  const tryCount = useRef(0);

  useEffect(() => {
    if (!featureFlags) return;

    const unsubscribe = featureFlags.setStateUpdateHandler(() => {
      if (tryCount.current >= maxTryCount) {
        return;
      }
      tryCount.current += 1;
      setStateUpdateCount((value) => value + 1);
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [featureFlags, setStateUpdateCount]);

  const providerValue = useMemo(() => {
    return { featureFlags };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureFlags, updateCount]);

  return (
    <FeatureFlagsContext.Provider value={providerValue}>{children}</FeatureFlagsContext.Provider>
  );
};
